import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import {
  BookOpen, Heart, Sparkles, Rocket, Ghost, Search, Leaf, Briefcase,
  Scroll, Landmark, FlaskConical, Brain, PenLine, Palette, Star, Baby,
  Flame, Zap, Send, HeartHandshake, Download, Lock,
  Library, PartyPopper, Compass, ArrowLeftRight, Building2,
  Sun, Activity, Monitor, BookMarked, Trophy, UtensilsCrossed, Feather, Eye,
} from 'lucide-react';

const GENEROS = [
  { id: 'ficcao',       label: 'Ficção',            Icon: BookOpen },
  { id: 'romance',      label: 'Romance',            Icon: Heart },
  { id: 'fantasia',     label: 'Fantasia',           Icon: Sparkles },
  { id: 'sci-fi',       label: 'Ficção Científica',  Icon: Rocket },
  { id: 'terror',       label: 'Terror',             Icon: Ghost },
  { id: 'misterio',     label: 'Mistério',           Icon: Search },
  { id: 'autoajuda',    label: 'Autoajuda',          Icon: Leaf },
  { id: 'negocios',     label: 'Negócios',           Icon: Briefcase },
  { id: 'biografia',    label: 'Biografia',          Icon: Scroll },
  { id: 'historia',     label: 'História',           Icon: Landmark },
  { id: 'ciencia',      label: 'Ciência',            Icon: FlaskConical },
  { id: 'filosofia',    label: 'Filosofia',         Icon: Brain },
  { id: 'poesia',       label: 'Poesia',             Icon: PenLine },
  { id: 'hq',           label: 'HQ / Quadrinhos',   Icon: Palette },
  { id: 'jovem-adulto',    label: 'Jovem Adulto',          Icon: Star },
  { id: 'infantil',        label: 'Infantil',              Icon: Baby },
  { id: 'religioso',       label: 'Religioso/Espiritual',  Icon: Sun },
  { id: 'thriller',        label: 'Thriller',              Icon: Eye },
  { id: 'saude',           label: 'Saúde & Bem-estar',     Icon: Activity },
  { id: 'tecnologia',      label: 'Tecnologia',            Icon: Monitor },
  { id: 'manga',           label: 'Mangá',                 Icon: BookMarked },
  { id: 'culinaria',       label: 'Culinária',             Icon: UtensilsCrossed },
  { id: 'esportes',        label: 'Esportes',              Icon: Trophy },
  { id: 'cronicas',        label: 'Crônicas',              Icon: Feather },
];

const LIVROS = [
  { id: '1', titulo: '1984', autor: 'George Orwell', isbn: '9780451524935' },
  { id: '2', titulo: 'A Revolução dos Bichos', autor: 'George Orwell', isbn: '9780452284241' },
  { id: '3', titulo: 'Admirável Mundo Novo', autor: 'Aldous Huxley', isbn: '9780060850524' },
  { id: '4', titulo: 'Fahrenheit 451', autor: 'Ray Bradbury', isbn: '9781451673319' },
  { id: '5', titulo: 'Dom Casmurro', autor: 'Machado de Assis', isbn: '9788535910551' },
  { id: '6', titulo: 'A Metamorfose', autor: 'Franz Kafka', isbn: '9780553213690' },
  { id: '7', titulo: 'O Retrato de Dorian Gray', autor: 'Oscar Wilde', isbn: '9780141439570' },
  { id: '8', titulo: 'Cem Anos de Solidão', autor: 'G. García Márquez', isbn: '9780060883287' },
  { id: '9', titulo: 'Crime e Castigo', autor: 'Dostoiévski', isbn: '9780140449136' },
  { id: '10', titulo: 'A Hora da Estrela', autor: 'Clarice Lispector', isbn: '9788531611506' },
  { id: '11', titulo: 'O Hobbit', autor: 'J.R.R. Tolkien', isbn: '9780261102217' },
  { id: '12', titulo: 'O Senhor dos Anéis', autor: 'J.R.R. Tolkien', isbn: '9780261102355' },
  { id: '13', titulo: 'Harry Potter 1', autor: 'J.K. Rowling', isbn: '9780439708180' },
  { id: '14', titulo: 'O Pequeno Príncipe', autor: 'Saint-Exupéry', isbn: '9780156013987' },
  { id: '15', titulo: 'As Crônicas de Nárnia', autor: 'C.S. Lewis', isbn: '9780064471190' },
  { id: '16', titulo: 'O Mundo de Sofia', autor: 'Jostein Gaarder', isbn: '9780425152928' },
  { id: '17', titulo: 'Duna', autor: 'Frank Herbert', isbn: '9780441013593' },
  { id: '18', titulo: 'Fundação', autor: 'Isaac Asimov', isbn: '9780553293357' },
  { id: '19', titulo: 'O Guia do Mochileiro', autor: 'Douglas Adams', isbn: '9780345391803' },
  { id: '20', titulo: 'Eu, Robô', autor: 'Isaac Asimov', isbn: '9780553294385' },
  { id: '21', titulo: 'Jogos Vorazes', autor: 'Suzanne Collins', isbn: '9780439023481' },
  { id: '22', titulo: 'Divergente', autor: 'Veronica Roth', isbn: '9780062024022' },
  { id: '23', titulo: 'Percy Jackson', autor: 'Rick Riordan', isbn: '9780786838653' },
  { id: '24', titulo: 'O Diário de um Banana', autor: 'Jeff Kinney', isbn: '9780810993136' },
  { id: '25', titulo: 'A Culpa é das Estrelas', autor: 'John Green', isbn: '9780525478812' },
  { id: '26', titulo: 'O Iluminado', autor: 'Stephen King', isbn: '9780307743657' },
  { id: '27', titulo: 'It - A Coisa', autor: 'Stephen King', isbn: '9781501156700' },
  { id: '28', titulo: 'Drácula', autor: 'Bram Stoker', isbn: '9780141439846' },
  { id: '29', titulo: 'Frankenstein', autor: 'Mary Shelley', isbn: '9780141439471' },
  { id: '30', titulo: 'O Código Da Vinci', autor: 'Dan Brown', isbn: '9780307474278' },
  { id: '31', titulo: 'Assassinato no Expresso', autor: 'Agatha Christie', isbn: '9780062693662' },
  { id: '32', titulo: 'O Nome da Rosa', autor: 'Umberto Eco', isbn: '9780156001311' },
  { id: '33', titulo: 'A Garota do Trem', autor: 'Paula Hawkins', isbn: '9781594634024' },
  { id: '34', titulo: 'Garota Exemplar', autor: 'Gillian Flynn', isbn: '9780307588371' },
  { id: '35', titulo: 'A Sombra do Vento', autor: 'Carlos Ruiz Zafón', isbn: '9780143034902' },
  { id: '36', titulo: 'Orgulho e Preconceito', autor: 'Jane Austen', isbn: '9780141439518' },
  { id: '37', titulo: 'Me Antes de Você', autor: 'Jojo Moyes', isbn: '9780143124542' },
  { id: '38', titulo: 'A Menina que Roubava Livros', autor: 'Markus Zusak', isbn: '9780375842207' },
  { id: '39', titulo: 'A Cabana', autor: 'W. Paul Young', isbn: '9780964729230' },
  { id: '40', titulo: 'O Caçador de Pipas', autor: 'Khaled Hosseini', isbn: '9781594480003' },
  { id: '41', titulo: 'O Alquimista', autor: 'Paulo Coelho', isbn: '9780062315007' },
  { id: '42', titulo: 'Hábitos Atômicos', autor: 'James Clear', isbn: '9780735211292' },
  { id: '43', titulo: 'O Poder do Hábito', autor: 'Charles Duhigg', isbn: '9780812981605' },
  { id: '44', titulo: 'Mindset', autor: 'Carol Dweck', isbn: '9780345472328' },
  { id: '45', titulo: 'O Poder do Agora', autor: 'Eckhart Tolle', isbn: '9781577314806' },
  { id: '46', titulo: 'Essencialismo', autor: 'Greg McKeown', isbn: '9780804137386' },
  { id: '47', titulo: 'Como Fazer Amigos', autor: 'Dale Carnegie', isbn: '9780671027032' },
  { id: '48', titulo: 'A Arte da Guerra', autor: 'Sun Tzu', isbn: '9781590302255' },
  { id: '49', titulo: 'Pai Rico, Pai Pobre', autor: 'Robert Kiyosaki', isbn: '9781612680194' },
  { id: '50', titulo: 'Rápido e Devagar', autor: 'Daniel Kahneman', isbn: '9780374533557' },
  { id: '51', titulo: 'Steve Jobs', autor: 'Walter Isaacson', isbn: '9781451648539' },
  { id: '52', titulo: 'Elon Musk', autor: 'Ashlee Vance', isbn: '9780062301253' },
  { id: '53', titulo: 'Longa Caminhada à Liberdade', autor: 'Nelson Mandela', isbn: '9780316548182' },
  { id: '54', titulo: 'O Diário de Anne Frank', autor: 'Anne Frank', isbn: '9780553577129' },
  { id: '55', titulo: 'Sapiens', autor: 'Yuval Noah Harari', isbn: '9780062316097' },
  { id: '56', titulo: 'Uma Breve História do Tempo', autor: 'Stephen Hawking', isbn: '9780553380163' },
  { id: '57', titulo: 'Watchmen', autor: 'Alan Moore', isbn: '9781401245252' },
  { id: '58', titulo: 'Maus', autor: 'Art Spiegelman', isbn: '9780679748403' },
  { id: '59', titulo: 'Persépolis', autor: 'Marjane Satrapi', isbn: '9780375714573' },
  { id: '60', titulo: 'Dom Quixote', autor: 'Miguel de Cervantes', isbn: '9780060934347' },
];

const RITMOS = [
  { id: '1-5',   Icon: Leaf,     titulo: '1 a 5 livros por ano',  subtitulo: 'Leitor casual' },
  { id: '6-12',  Icon: BookOpen, titulo: '6 a 12 livros por ano', subtitulo: 'Leitor regular' },
  { id: '13-24', Icon: Flame,    titulo: '13 a 24 livros por ano',subtitulo: 'Leitor dedicado' },
  { id: '24+',   Icon: Zap,      titulo: 'Mais de 24 por ano',    subtitulo: 'Devorador de livros' },
];

const EMPRESTIMOS = [
  { id: 'adoro-emprestar',  Icon: Send,          label: 'Adoro emprestar meus livros' },
  { id: 'empresto-criterio',Icon: HeartHandshake,label: 'Empresto, mas gosto de manter o controle' },
  { id: 'prefiro-pegar',    Icon: Download,      label: 'Prefiro pegar livros emprestados' },
  { id: 'nao-gosto',        Icon: Lock,          label: 'Não gosto de emprestar livros' },
];

const BRAND = 'linear-gradient(150deg,#6E50F0,#3F27B0)';
const TOTAL_STEPS = 5;

export default function Onboarding({ userId, nomeUsuario, onConcluir, onPular }) {
  const navigate = useNavigate();
  const [etapa, setEtapa] = useState(0);

  // Garante que o flag de nova_conta é removido assim que o onboarding monta,
  // evitando que onAuthStateChange redirecione de volta ao navegar para /home
  useEffect(() => { localStorage.removeItem('nova_conta'); }, []);
  const [dataNasc, setDataNasc] = useState('');
  const [generosSel, setGenerosSel] = useState([]);
  const [livrosSel, setLivrosSel] = useState([]);
  const [ritmo, setRitmo] = useState('');
  const [emprestimo, setEmprestimo] = useState('');
  const [modoPrivado, setModoPrivado] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const isMobile = window.innerWidth < 1024;

  function podeAvancar() {
    if (etapa === 0) return true;
    if (etapa === 1) return dataNasc.length > 0;
    if (etapa === 2) return generosSel.length >= 1;
    if (etapa === 3) return livrosSel.length >= 3;
    if (etapa === 4) return ritmo.length > 0;
    if (etapa === 5) return emprestimo.length > 0;
    return true;
  }

  function toggleGenero(id) {
    setGenerosSel(prev => prev.includes(id) ? prev.filter(g => g !== id) : [...prev, id]);
  }

  function toggleLivro(id) {
    setLivrosSel(prev => prev.includes(id) ? prev.filter(l => l !== id) : [...prev, id]);
  }

  async function concluir() {
    localStorage.removeItem('nova_conta');
    setSalvando(true);
    if (userId) {
      await supabase.from('perfis').update({
        data_nascimento: dataNasc || null,
        generos_favoritos: generosSel,
        livros_favoritos: livrosSel,
        ritmo_leitura: ritmo,
        preferencia_emprestimo: emprestimo,
        ...(emprestimo === 'nao-gosto' && modoPrivado === true ? { pausada: true } : {}),
      }).eq('id', userId);
    }
    setSalvando(false);
    if (onConcluir) onConcluir(true);
    else navigate('/home');
  }

  function irParaHome() {
    localStorage.removeItem('nova_conta');
    if (onPular) onPular();
    else navigate('/home');
  }

  function avancar() {
    if (etapa < 6) setEtapa(e => e + 1);
  }

  function voltar() {
    if (etapa > 0) setEtapa(e => e - 1);
  }

  // Enter key para avançar (ignora quando foco está em input/textarea)
  useEffect(() => {
    const handler = (e) => {
      if (e.key !== 'Enter' || salvando) return;
      const tag = document.activeElement?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'BUTTON') return;
      if (!podeAvancar()) return;
      if (etapa === 6) concluir();
      else avancar();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  });

  const firstName = nomeUsuario?.split(' ')[0] || 'você';

  const btnLabel = () => {
    if (salvando) return 'Salvando…';
    if (etapa === 0) return 'Vamos lá!';
    if (etapa === 6) return 'Adicionar meu primeiro livro';
    if (etapa === 3 && livrosSel.length < 3) {
      const faltam = 3 - livrosSel.length;
      return `Selecione mais ${faltam}`;
    }
    return 'Continuar →';
  };

  return (
    <div className="font-sans select-none lg:min-h-screen lg:bg-paper lg:flex lg:items-center lg:justify-center"
      style={{ height: isMobile ? '100dvh' : 'auto', background: isMobile ? 'white' : undefined }}>
    <div className="bg-white flex flex-col w-full lg:max-w-[480px] lg:rounded-2xl lg:shadow-xl lg:border lg:border-line-soft lg:overflow-hidden"
      style={{ height: isMobile ? '100dvh' : 'auto', maxHeight: isMobile ? '100dvh' : '90vh', paddingTop: 'env(safe-area-inset-top)' }}>

      {/* Barra de progresso */}
      {etapa >= 1 && etapa <= 5 && (
        <div className="px-5 pt-4 pb-1 flex-shrink-0">
          <p className="text-[11px] text-ink-400 mb-1.5">{etapa} de {TOTAL_STEPS}</p>
          <div className="h-1.5 bg-line rounded-full overflow-hidden">
            <div className="h-full rounded-full transition-all duration-500"
              style={{ width: `${(etapa / TOTAL_STEPS) * 100}%`, background: BRAND }} />
          </div>
        </div>
      )}

      {/* Conteúdo scrollável */}
      <div className="flex-1 overflow-y-auto">
        {etapa === 0 && <StepBemVindo firstName={firstName} />}
        {etapa === 1 && <StepNascimento value={dataNasc} onChange={setDataNasc} />}
        {etapa === 2 && <StepGeneros selected={generosSel} toggle={toggleGenero} />}
        {etapa === 3 && <StepLivros selected={livrosSel} toggle={toggleLivro} />}
        {etapa === 4 && <StepRitmo value={ritmo} onChange={setRitmo} />}
        {etapa === 5 && <StepEmprestimo value={emprestimo} onChange={setEmprestimo} modoPrivado={modoPrivado} setModoPrivado={setModoPrivado} />}
        {etapa === 6 && <StepConclusao firstName={firstName} />}
      </div>

      {/* Botões de navegação */}
      <div className="flex-shrink-0 px-5 pt-3 flex flex-col gap-2"
        style={{ paddingBottom: 'calc(24px + env(safe-area-inset-bottom))' }}>
        <div className="flex gap-3">
          {etapa > 0 && etapa < 6 && (
            <button onClick={voltar}
              className="w-11 h-11 rounded-[13px] border border-line flex items-center justify-center text-ink-500 bg-white flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6"/>
              </svg>
            </button>
          )}
          <button
            onClick={etapa === 6 ? concluir : avancar}
            disabled={!podeAvancar() || salvando}
            className="flex-1 py-3.5 rounded-[14px] text-white font-bold text-[15px] transition-opacity disabled:opacity-40"
            style={{ background: BRAND }}>
            {btnLabel()}
          </button>
        </div>
        {etapa === 0 && (
          <button onClick={irParaHome} disabled={salvando}
            className="text-center text-[13px] font-semibold text-ink-400 py-1.5">
            Pular onboarding
          </button>
        )}
        {etapa >= 1 && etapa <= 5 && (
          <button onClick={avancar}
            className="text-center text-[13px] font-semibold text-ink-400 py-1.5">
            Pular esta pergunta
          </button>
        )}
        {etapa === 6 && (
          <button onClick={irParaHome} disabled={salvando}
            className="text-center text-[13px] font-semibold text-ink-400 py-1.5">
            Explorar primeiro
          </button>
        )}
      </div>
    </div>
    </div>
  );
}

function StepBemVindo({ firstName }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-8 text-center">
      <div className="mb-6 w-[88px] h-[88px] rounded-[28px] flex items-center justify-center" style={{background:'linear-gradient(150deg,#EDE9FF,#D8D0FF)'}}>
        <Library size={44} strokeWidth={1.4} color="#5B3CE4" />
      </div>
      <h1 className="text-[28px] font-extrabold text-ink-900 mb-3 leading-tight">
        Olá, {firstName}!
      </h1>
      <p className="text-[15px] text-ink-500 leading-relaxed max-w-xs">
        Bem-vindo à <strong className="text-ink-900">Biblioteca de Bolso</strong>.
        Vamos personalizar sua experiência com algumas perguntas rápidas.
      </p>
      <p className="text-[13px] text-ink-400 mt-5 bg-paper px-4 py-2 rounded-full">
        Menos de 2 minutos
      </p>
    </div>
  );
}

function StepNascimento({ value, onChange }) {
  const hoje = new Date().toISOString().split('T')[0];
  const min = new Date();
  min.setFullYear(min.getFullYear() - 110);
  const minStr = min.toISOString().split('T')[0];

  return (
    <div className="px-5 pt-8 pb-4">
      <p className="text-[12px] font-bold text-brand uppercase tracking-widest mb-3">Sobre você</p>
      <h2 className="text-[26px] font-extrabold text-ink-900 mb-2 leading-tight">Quando você nasceu?</h2>
      <p className="text-[14px] text-ink-400 mb-8">
        Usaremos isso para personalizar sua experiência.
      </p>
      <input
        type="date"
        value={value}
        onChange={e => onChange(e.target.value)}
        max={hoje}
        min={minStr}
        className="w-full border-2 rounded-[14px] px-4 py-4 text-[16px] text-ink-900 bg-paper outline-none transition-colors"
        style={{ borderColor: value ? '#5B3CE4' : '#EAE5DC' }}
      />
    </div>
  );
}

function StepGeneros({ selected, toggle }) {
  return (
    <div className="px-5 pt-8 pb-4">
      <p className="text-[12px] font-bold text-brand uppercase tracking-widest mb-3">Seus gostos</p>
      <h2 className="text-[26px] font-extrabold text-ink-900 mb-2 leading-tight">Que livros você curte?</h2>
      <p className="text-[14px] text-ink-400 mb-6">
        Escolha todos que gostar
        {selected.length > 0 && (
          <span className="ml-1 font-semibold text-brand">• {selected.length} selecionado{selected.length > 1 ? 's' : ''}</span>
        )}
      </p>
      <div className="flex flex-wrap gap-2">
        {GENEROS.map(g => {
          const sel = selected.includes(g.id);
          return (
            <button key={g.id} onClick={() => toggle(g.id)}
              className="flex items-center gap-1.5 px-4 py-2.5 rounded-[12px] text-[13px] font-semibold border-2 transition-all"
              style={{
                borderColor: sel ? '#5B3CE4' : '#EAE5DC',
                background: sel ? '#F0ECFF' : '#FAFAF8',
                color: sel ? '#5B3CE4' : '#5A5368',
              }}>
              <g.Icon size={13} strokeWidth={2} />
              <span>{g.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

function BookCover({ livro, selected, onToggle }) {
  const [imgError, setImgError] = useState(false);
  const coverUrl = `https://covers.openlibrary.org/b/isbn/${livro.isbn}-M.jpg`;

  return (
    <div onClick={() => onToggle(livro.id)} className="cursor-pointer relative">
      <div className="rounded-[10px] overflow-hidden transition-all"
        style={{
          aspectRatio: '2/3',
          outline: selected ? '2.5px solid #5B3CE4' : '2.5px solid transparent',
          boxShadow: selected ? '0 0 0 3px #C5B8F8' : '0 2px 8px rgba(0,0,0,0.10)',
        }}>
        {!imgError ? (
          <img src={coverUrl} alt={livro.titulo}
            onError={() => setImgError(true)}
            className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-end p-1.5"
            style={{ background: 'linear-gradient(150deg,#6E50F0,#3F27B0)' }}>
            <div>
              <p className="text-white text-[8px] font-bold leading-tight line-clamp-3">{livro.titulo}</p>
              <p className="text-purple-200 text-[7px] mt-0.5 leading-tight line-clamp-1">{livro.autor}</p>
            </div>
          </div>
        )}
      </div>
      {selected && (
        <div className="absolute top-1 right-1 w-5 h-5 rounded-full flex items-center justify-center"
          style={{ background: '#5B3CE4' }}>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white"
            strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
      )}
    </div>
  );
}

function StepLivros({ selected, toggle }) {
  const [visíveis, setVisíveis] = useState(12);
  const sentinelRef = useRef(null);
  const livrosVisiveis = LIVROS.slice(0, visíveis);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el || visíveis >= LIVROS.length) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisíveis(v => Math.min(v + 6, LIVROS.length)); },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [visíveis]);

  return (
    <div className="px-4 pt-8 pb-4">
      <div className="px-1 mb-6">
        <p className="text-[12px] font-bold text-brand uppercase tracking-widest mb-3">Seus livros</p>
        <h2 className="text-[26px] font-extrabold text-ink-900 mb-2 leading-tight">Quais você já leu ou gostou?</h2>
        <p className="text-[14px] text-ink-400">
          Escolha pelo menos 3
          {selected.length > 0 && (
            <span className="ml-1 font-semibold text-brand">• {selected.length} selecionado{selected.length > 1 ? 's' : ''}</span>
          )}
        </p>
      </div>
      <div className="grid grid-cols-3 gap-2.5">
        {livrosVisiveis.map(livro => (
          <BookCover key={livro.id} livro={livro}
            selected={selected.includes(livro.id)} onToggle={toggle} />
        ))}
      </div>
      <div ref={sentinelRef} className="h-4" />
    </div>
  );
}

function StepRitmo({ value, onChange }) {
  return (
    <div className="px-5 pt-8 pb-4">
      <p className="text-[12px] font-bold text-brand uppercase tracking-widest mb-3">Seus hábitos</p>
      <h2 className="text-[26px] font-extrabold text-ink-900 mb-2 leading-tight">Qual é seu ritmo de leitura?</h2>
      <p className="text-[14px] text-ink-400 mb-6">Uma estimativa já está ótimo!</p>
      <div className="flex flex-col gap-3">
        {RITMOS.map(r => {
          const sel = value === r.id;
          return (
            <button key={r.id} onClick={() => onChange(r.id)}
              className="flex items-center gap-4 p-4 rounded-[16px] border-2 text-left transition-all w-full"
              style={{ borderColor: sel ? '#5B3CE4' : '#EAE5DC', background: sel ? '#F0ECFF' : '#FAFAF8' }}>
              <div className="flex-shrink-0 w-9 h-9 rounded-[11px] flex items-center justify-center" style={{background: sel ? '#DDD6FA' : '#EDE8FF'}}>
                <r.Icon size={20} strokeWidth={1.8} color={sel ? '#5B3CE4' : '#8B72E4'} />
              </div>
              <div className="flex-1">
                <p className="text-[15px] font-bold" style={{ color: sel ? '#5B3CE4' : '#1A1523' }}>{r.titulo}</p>
                <p className="text-[12px]" style={{ color: sel ? '#7B5CE4' : '#9A93A4' }}>{r.subtitulo}</p>
              </div>
              <div className="w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all"
                style={{ borderColor: sel ? '#5B3CE4' : '#D0C8E0', background: sel ? '#5B3CE4' : 'white' }}>
                {sel && (
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white"
                    strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

function StepEmprestimo({ value, onChange, modoPrivado, setModoPrivado }) {
  return (
    <div className="px-5 pt-8 pb-4">
      <p className="text-[12px] font-bold text-brand uppercase tracking-widest mb-3">Sobre empréstimos</p>
      <h2 className="text-[26px] font-extrabold text-ink-900 mb-2 leading-tight">Como você se sente sobre emprestar livros?</h2>
      <p className="text-[14px] text-ink-400 mb-6">Escolha a que mais combina com você</p>
      <div className="flex flex-col gap-3">
        {EMPRESTIMOS.map(e => {
          const sel = value === e.id;
          return (
            <button key={e.id} onClick={() => onChange(e.id)}
              className="flex items-center gap-4 p-4 rounded-[16px] border-2 text-left transition-all w-full"
              style={{ borderColor: sel ? '#5B3CE4' : '#EAE5DC', background: sel ? '#F0ECFF' : '#FAFAF8' }}>
              <div className="flex-shrink-0 w-9 h-9 rounded-[11px] flex items-center justify-center" style={{background: sel ? '#DDD6FA' : '#EDE8FF'}}>
                <e.Icon size={18} strokeWidth={1.8} color={sel ? '#5B3CE4' : '#8B72E4'} />
              </div>
              <p className="flex-1 text-[14px] font-semibold leading-snug"
                style={{ color: sel ? '#5B3CE4' : '#1A1523' }}>{e.label}</p>
              <div className="w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all"
                style={{ borderColor: sel ? '#5B3CE4' : '#D0C8E0', background: sel ? '#5B3CE4' : 'white' }}>
                {sel && (
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white"
                    strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </div>
            </button>
          );
        })}
      </div>

      {value === 'nao-gosto' && (
        <div className="mt-5 p-4 rounded-[16px] border-2 border-line bg-paper">
          <p className="text-[14px] font-bold text-ink-900 mb-1">Quer ativar a biblioteca privada?</p>
          <p className="text-[12px] text-ink-400 mb-4">Sua conta fica oculta para outros usuários. Você ainda pode usar o app e compartilhar o link da sua biblioteca com quem quiser.</p>
          <div className="flex gap-2">
            <button
              onClick={() => setModoPrivado(true)}
              className="flex-1 py-2.5 rounded-[12px] border-2 text-[13px] font-bold transition-all"
              style={{ borderColor: modoPrivado === true ? '#5B3CE4' : '#EAE5DC', background: modoPrivado === true ? '#F0ECFF' : 'white', color: modoPrivado === true ? '#5B3CE4' : '#5A5368' }}>
              Sim, ativar
            </button>
            <button
              onClick={() => setModoPrivado(false)}
              className="flex-1 py-2.5 rounded-[12px] border-2 text-[13px] font-bold transition-all"
              style={{ borderColor: modoPrivado === false ? '#5B3CE4' : '#EAE5DC', background: modoPrivado === false ? '#F0ECFF' : 'white', color: modoPrivado === false ? '#5B3CE4' : '#5A5368' }}>
              Não agora
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function StepConclusao({ firstName }) {
  const features = [
    { Icon: BookOpen,      texto: 'Organize seu acervo pessoal' },
    { Icon: Compass,       texto: 'Descubra livros na comunidade' },
    { Icon: ArrowLeftRight,texto: 'Empreste e peça emprestado' },
    { Icon: Building2,     texto: 'Participe de clubes de leitura' },
  ];
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-8 text-center">
      <div className="mb-6 w-[88px] h-[88px] rounded-[28px] flex items-center justify-center" style={{background:'linear-gradient(150deg,#EDE9FF,#D8D0FF)'}}>
        <PartyPopper size={44} strokeWidth={1.4} color="#5B3CE4" />
      </div>
      <h1 className="text-[28px] font-extrabold text-ink-900 mb-3 leading-tight">
        Tudo pronto, {firstName}!
      </h1>
      <p className="text-[15px] text-ink-500 leading-relaxed max-w-xs">
        Comece adicionando os livros que você tem em casa — assim outros leitores perto de você podem pedir emprestado.
      </p>
      <div className="mt-8 flex flex-col gap-3 w-full max-w-xs">
        {features.map((item, i) => (
          <div key={i} className="flex items-center gap-3 bg-paper px-4 py-3 rounded-[13px] text-left">
            <div className="w-8 h-8 rounded-[10px] flex items-center justify-center flex-shrink-0" style={{background:'#EDE9FF'}}>
              <item.Icon size={16} strokeWidth={1.8} color="#5B3CE4" />
            </div>
            <p className="text-[13px] font-semibold text-ink-700">{item.texto}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
